// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.AppMenu {
    text-align: right;
    cursor: default;
    transition: background-color 0.25s;
    outline: none;
    overflow: hidden;
    display: flex;
    align-items: center;
}

div.AppMenu.appmenu-visible {
    background-color: var(--app-submenu-bg-color-hover);
    color: var(--app-submenu-text-color-hover);
    overflow: visible;
}


div.AppMenu .appmenu-label {
    font-weight: bold;
    transition: color 0.25s;
}

div.AppMenu .appmenu-icon {
    color: var(--app-menu-text-color);
    padding: 0.25em;
    margin: 0 1em;
    border: 2px solid var(--app-menu-text-color);
    transition: color 0.25s, border-color 0.25s, background-color 0.25s;
}

div.AppMenu.appmenu-visible .appmenu-icon {
    color: var(--app-submenu-text-color-hover);
    border-color: var(--app-submenu-text-color-hover);
    background-color: inherit;
}

div.AppMenu.appmenu-blocked {
    cursor: not-allowed;
}

div.AppMenu div.appmenu-menu-container {
    position: absolute;
    top: 100%;
    right: 0;
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
    width: 20em;
    max-width: 100vw;
    opacity: 0;
    transform-origin: top;
    transform: scaleY(0);
    transition: transform 0.25s, opacity 0.25s;
    overflow-y: auto;
    max-height: calc(100vh - var(--topbar-height) - var(--bottombar-height));
    max-height: calc(var(--vh, 1vh) * 100 - var(--topbar-height) - var(--bottombar-height));
}

div.AppMenu.appmenu-compact div.appmenu-menu-container {
    right: -11.25em;
    width: 15em;
    height: calc(100vh - 5.5em);
    transition: transform 0.25s, opacity 0.25s, right 0.5s;
    background: var(--app-menu-bg-color);
    box-shadow: 0px 0px 4px rgba(136, 136, 136, 0.5);
    top: 3.5em;
}

div.AppMenu.appmenu-compact div.appmenu-menu-container:hover {
    right: 0;
}

div.AppMenu ul.appmenu-menu {
    text-align: left;
    padding: 0;
    background-color: var(--app-menu-bg-color);
}

div.AppMenu.appmenu-visible div.appmenu-menu-container {
    transform: scaleY(1);
    opacity: 1;
}

div.AppMenu ul.appmenu-menu li {
    color: var(--app-menu-text-color);
    list-style-type: none;
    margin: 0;
    font-size: small;
    font-weight: bold;
}

div.AppMenu ul.appmenu-menu li:not(:last-child) {
    border-bottom: 1px solid var(--app-menu-text-color);
}

div.AppMenu ul.appmenu-menu > li.appmenu-leaf-active,
div.AppMenu ul.appmenu-menu > li.appmenu-submenu-active,
div.AppMenu ul.appmenu-menu > li.appmenu-submenu-expanded {
    background-color: var(--app-menu-bg-color-hover);
    color: var(--app-menu-text-color-hover);
}

div.AppMenu ul.appmenu-menu li > .icon {
    vertical-align: middle;
    width: 2em;
    margin: 0.5em 1em 0.5em 1em;
}

div.AppMenu ul.appmenu-menu li.appmenu-submenu > ul {
    background-color: var(--app-submenu-bg-color);
    padding: 0;
    display: none;
}

div.AppMenu ul.appmenu-menu li.appmenu-submenu-expanded > ul {
    display: block;
}

div.AppMenu ul.appmenu-menu li.appmenu-submenu > ul > li {
    color: var(--app-submenu-text-color);
}

div.AppMenu ul.appmenu-menu li.appmenu-submenu > ul > li.appmenu-leaf-active,
div.AppMenu ul.appmenu-menu li.appmenu-submenu > ul > li.appmenu-submenu-active,
div.AppMenu ul.appmenu-menu li.appmenu-submenu > ul > li.appmenu-submenu-expanded {
    background-color: var(--app-submenu-bg-color-hover);
    color: var(--app-submenu-text-color-hover);
}

div.AppMenu ul.appmenu-menu li.appmenu-leaf {
    display: flex;
    align-items: center;
}

div.AppMenu ul.appmenu-menu li.appmenu-leaf > span.icon {
    flex: 0 0 auto;
}

div.AppMenu ul.appmenu-menu li.appmenu-leaf > span.appmenu-leaf-label {
    flex: 1 1 auto;
    margin: 0.25em 0;
}

div.AppMenu ul.appmenu-menu li.appmenu-leaf div.appmenu-leaf-comment {
    font-weight: normal;
    font-size: 90%;
}

div.appmenu-filter {
    width: 100%;
    margin-right: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/style/AppMenu.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mDAAmD;IACnD,0CAA0C;IAC1C,iBAAiB;AACrB;;;AAGA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,aAAa;IACb,4CAA4C;IAC5C,mEAAmE;AACvE;;AAEA;IACI,0CAA0C;IAC1C,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gDAAgD;IAChD,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,wEAAwE;IACxE,uFAAuF;AAC3F;;AAEA;IACI,eAAe;IACf,WAAW;IACX,2BAA2B;IAC3B,sDAAsD;IACtD,oCAAoC;IACpC,gDAAgD;IAChD,UAAU;AACd;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;;;IAGI,gDAAgD;IAChD,uCAAuC;AAC3C;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,6CAA6C;IAC7C,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,mDAAmD;IACnD,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB","sourcesContent":["div.AppMenu {\n    text-align: right;\n    cursor: default;\n    transition: background-color 0.25s;\n    outline: none;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n}\n\ndiv.AppMenu.appmenu-visible {\n    background-color: var(--app-submenu-bg-color-hover);\n    color: var(--app-submenu-text-color-hover);\n    overflow: visible;\n}\n\n\ndiv.AppMenu .appmenu-label {\n    font-weight: bold;\n    transition: color 0.25s;\n}\n\ndiv.AppMenu .appmenu-icon {\n    color: var(--app-menu-text-color);\n    padding: 0.25em;\n    margin: 0 1em;\n    border: 2px solid var(--app-menu-text-color);\n    transition: color 0.25s, border-color 0.25s, background-color 0.25s;\n}\n\ndiv.AppMenu.appmenu-visible .appmenu-icon {\n    color: var(--app-submenu-text-color-hover);\n    border-color: var(--app-submenu-text-color-hover);\n    background-color: inherit;\n}\n\ndiv.AppMenu.appmenu-blocked {\n    cursor: not-allowed;\n}\n\ndiv.AppMenu div.appmenu-menu-container {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n    width: 20em;\n    max-width: 100vw;\n    opacity: 0;\n    transform-origin: top;\n    transform: scaleY(0);\n    transition: transform 0.25s, opacity 0.25s;\n    overflow-y: auto;\n    max-height: calc(100vh - var(--topbar-height) - var(--bottombar-height));\n    max-height: calc(var(--vh, 1vh) * 100 - var(--topbar-height) - var(--bottombar-height));\n}\n\ndiv.AppMenu.appmenu-compact div.appmenu-menu-container {\n    right: -11.25em;\n    width: 15em;\n    height: calc(100vh - 5.5em);\n    transition: transform 0.25s, opacity 0.25s, right 0.5s;\n    background: var(--app-menu-bg-color);\n    box-shadow: 0px 0px 4px rgba(136, 136, 136, 0.5);\n    top: 3.5em;\n}\n\ndiv.AppMenu.appmenu-compact div.appmenu-menu-container:hover {\n    right: 0;\n}\n\ndiv.AppMenu ul.appmenu-menu {\n    text-align: left;\n    padding: 0;\n    background-color: var(--app-menu-bg-color);\n}\n\ndiv.AppMenu.appmenu-visible div.appmenu-menu-container {\n    transform: scaleY(1);\n    opacity: 1;\n}\n\ndiv.AppMenu ul.appmenu-menu li {\n    color: var(--app-menu-text-color);\n    list-style-type: none;\n    margin: 0;\n    font-size: small;\n    font-weight: bold;\n}\n\ndiv.AppMenu ul.appmenu-menu li:not(:last-child) {\n    border-bottom: 1px solid var(--app-menu-text-color);\n}\n\ndiv.AppMenu ul.appmenu-menu > li.appmenu-leaf-active,\ndiv.AppMenu ul.appmenu-menu > li.appmenu-submenu-active,\ndiv.AppMenu ul.appmenu-menu > li.appmenu-submenu-expanded {\n    background-color: var(--app-menu-bg-color-hover);\n    color: var(--app-menu-text-color-hover);\n}\n\ndiv.AppMenu ul.appmenu-menu li > .icon {\n    vertical-align: middle;\n    width: 2em;\n    margin: 0.5em 1em 0.5em 1em;\n}\n\ndiv.AppMenu ul.appmenu-menu li.appmenu-submenu > ul {\n    background-color: var(--app-submenu-bg-color);\n    padding: 0;\n    display: none;\n}\n\ndiv.AppMenu ul.appmenu-menu li.appmenu-submenu-expanded > ul {\n    display: block;\n}\n\ndiv.AppMenu ul.appmenu-menu li.appmenu-submenu > ul > li {\n    color: var(--app-submenu-text-color);\n}\n\ndiv.AppMenu ul.appmenu-menu li.appmenu-submenu > ul > li.appmenu-leaf-active,\ndiv.AppMenu ul.appmenu-menu li.appmenu-submenu > ul > li.appmenu-submenu-active,\ndiv.AppMenu ul.appmenu-menu li.appmenu-submenu > ul > li.appmenu-submenu-expanded {\n    background-color: var(--app-submenu-bg-color-hover);\n    color: var(--app-submenu-text-color-hover);\n}\n\ndiv.AppMenu ul.appmenu-menu li.appmenu-leaf {\n    display: flex;\n    align-items: center;\n}\n\ndiv.AppMenu ul.appmenu-menu li.appmenu-leaf > span.icon {\n    flex: 0 0 auto;\n}\n\ndiv.AppMenu ul.appmenu-menu li.appmenu-leaf > span.appmenu-leaf-label {\n    flex: 1 1 auto;\n    margin: 0.25em 0;\n}\n\ndiv.AppMenu ul.appmenu-menu li.appmenu-leaf div.appmenu-leaf-comment {\n    font-weight: normal;\n    font-size: 90%;\n}\n\ndiv.appmenu-filter {\n    width: 100%;\n    margin-right: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
